/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Use_PhotoInputs */

const en_us2_body_assessment_use_photo = /** @type {(inputs: Body_Assessment_Use_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this photo`)
};

const pt_br2_body_assessment_use_photo = /** @type {(inputs: Body_Assessment_Use_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar esta foto`)
};

const es_419_body_assessment_use_photo = /** @type {(inputs: Body_Assessment_Use_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar esta foto`)
};

const pt_pt2_body_assessment_use_photo = /** @type {(inputs: Body_Assessment_Use_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar esta foto`)
};

const fr_fr2_body_assessment_use_photo = /** @type {(inputs: Body_Assessment_Use_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser cette photo`)
};

const de_de2_body_assessment_use_photo = /** @type {(inputs: Body_Assessment_Use_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto verwenden`)
};

const it_it2_body_assessment_use_photo = /** @type {(inputs: Body_Assessment_Use_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa questa foto`)
};

/**
* | output |
* | --- |
* | "Use this photo" |
*
* @param {Body_Assessment_Use_PhotoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_use_photo = /** @type {((inputs?: Body_Assessment_Use_PhotoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Use_PhotoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_use_photo(inputs)
	if (locale === "es-419") return es_419_body_assessment_use_photo(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_use_photo(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_use_photo(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_use_photo(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_use_photo(inputs)
	return en_us2_body_assessment_use_photo(inputs)
});
export { body_assessment_use_photo as "body-assessment.use_photo" }